import { render, staticRenderFns } from "./DictUseWaterSource.vue?vue&type=template&id=f2683f92&scoped=true&"
import script from "./DictUseWaterSource.vue?vue&type=script&lang=js&"
export * from "./DictUseWaterSource.vue?vue&type=script&lang=js&"
import style0 from "./DictUseWaterSource.vue?vue&type=style&index=0&id=f2683f92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2683f92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2683f92')) {
      api.createRecord('f2683f92', component.options)
    } else {
      api.reload('f2683f92', component.options)
    }
    module.hot.accept("./DictUseWaterSource.vue?vue&type=template&id=f2683f92&scoped=true&", function () {
      api.rerender('f2683f92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/DictUseWaterSource.vue"
export default component.exports